import Tooltip from '@mui/material/Tooltip';
import type { DataTableColumn } from '@aeg-presents/shared-components/DataTable';
import { formatAbsoluteNumber, formatCurrency, formatFeedSales, formatPercent } from '@utils/numberFormatters';
import { TicketAllocation } from '@app-types/ticketSales';
import { DATE_FORMATS, formatDate } from '@utils/dateFormatters';

function formatNumberCell(value: number | string | null | undefined): string {
  return typeof value === 'string' ? value : formatAbsoluteNumber(value, '-');
}

export const allocationTableColumns: DataTableColumn<TicketAllocation>[] = [
  {
    field: 'ticketCompany',
    headerName: 'Ticket Company',
    flex: 1,
    minWidth: 100,
    sortable: true,
    disabled: true,
  },
  {
    field: 'ticketType',
    headerName: 'Ticket Type',
    flex: 1,
    minWidth: 100,
    sortable: false,
    disabled: true,
  },
  {
    field: 'ticketName',
    headerName: 'Ticket Name',
    flex: 1,
    minWidth: 100,
    sortable: false,
    disabled: true,
  },
  {
    field: 'allocation',
    headerName: 'Allocation',
    flex: 1,
    minWidth: 100,
    sortable: false,
    disabled: true,
    valueFormatter: (value: number | string | null | undefined) => formatNumberCell(value),
  },
  {
    field: 'price',
    headerName: 'Price',
    flex: 1,
    minWidth: 100,
    sortable: false,
    disabled: true,
    renderCell: (params) => formatCurrency(params.row.price, 'GBP', '-'),
  },
  {
    field: 'lastUpdated',
    headerName: 'Last Updated',
    flex: 1,
    minWidth: 100,
    sortable: false,
    disabled: true,
    valueGetter: (_value, row) => formatDate(row.lastUpdated, DATE_FORMATS.DATE_WITH_DATETIME) || '-',
  },
  {
    field: 'feedSales',
    headerName: 'Feed Sales',
    flex: 1,
    minWidth: 100,
    sortable: false,
    disabled: true,
    renderCell: (params) => {
      const feedSales = params.row.feedSales;
      return typeof feedSales === 'number' ? formatFeedSales(feedSales) : (feedSales ?? 'N/A');
    },
  },
  {
    field: 'manualSales',
    headerName: 'Manual Sales',
    flex: 1,
    minWidth: 100,
    sortable: false,
    disabled: true,
    type: 'number',
    align: 'left',
    headerAlign: 'left',
    valueParser: (value) => {
      const parsed = Number(value);
      return Number.isFinite(parsed) ? parsed : 0;
    },
    valueFormatter: (value: number | string | null | undefined) => formatNumberCell(value),
  },
  {
    field: 'totalSales',
    headerName: 'Total Sales',
    flex: 1,
    minWidth: 100,
    sortable: false,
    disabled: true,
    renderHeader: () => (
      <Tooltip title="Feed Sales + Manual Sales" placement="bottom" arrow>
        <span className="MuiDataGrid-columnHeaderTitle">Total Sales</span>
      </Tooltip>
    ),
    valueFormatter: (value: number | string | null | undefined) => formatNumberCell(value),
  },
  {
    field: 'percentSold',
    headerName: '% Sold',
    flex: 1,
    minWidth: 100,
    sortable: false,
    disabled: true,
    renderCell: (params) => formatPercent(params.row.percentSold, '-'),
  },
  {
    field: 'unsold',
    headerName: 'Unsold',
    flex: 1,
    minWidth: 100,
    sortable: false,
    disabled: true,
    valueFormatter: (value: number | string | null | undefined) => formatNumberCell(value),
  },
];
